"use strict";
import { DisplayNameType } from "features/accounts/types";
import { useENSName } from "features/ens/api";
import { UNITAG_SUFFIX } from "features/unitags/constants";
import { useUnitagByAddress } from "features/unitags/hooks";
import { getValidAddress, sanitizeAddressText } from "utils/addresses";
import { shortenAddress } from "utilities/src/addresses";
import { trimToLength } from "utilities/src/primitives/string";
const ENS_TRIM_LENGTH = 8;
export function useOnchainDisplayName(address, options) {
  const defaultOptions = {
    showShortenedEns: false,
    includeUnitagSuffix: false
  };
  const hookOptions = { ...defaultOptions, ...options };
  const { showShortenedEns, includeUnitagSuffix, overrideDisplayName } = hookOptions;
  const validated = getValidAddress(address);
  const ens = useENSName(validated ?? void 0);
  const { unitag } = useUnitagByAddress(validated ?? void 0);
  if (!address) {
    return void 0;
  }
  if (overrideDisplayName) {
    return {
      name: showShortenedEns ? trimToLength(overrideDisplayName, ENS_TRIM_LENGTH) : overrideDisplayName,
      type: DisplayNameType.ENS
    };
  }
  if (unitag?.username) {
    return {
      name: includeUnitagSuffix ? unitag.username + UNITAG_SUFFIX : unitag.username,
      type: DisplayNameType.Unitag
    };
  }
  if (ens.data) {
    return {
      name: showShortenedEns ? trimToLength(ens.data, ENS_TRIM_LENGTH) : ens.data,
      type: DisplayNameType.ENS
    };
  }
  return {
    name: `${sanitizeAddressText(shortenAddress(address))}`,
    type: DisplayNameType.Address
  };
}
